import React from "react";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import './Confirm.scss';
 
class Confirm extends React.Component {
    constructor(props){
        super(props)

    }
  submit = () => {
    confirmAlert({
      title:  this.props.title ? this.props.title :'Are you sure?',
      message: this.props.confirmMessage,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.props.getConfirmation(true),
          onMouseDown: (e) => this.props.getConfirmation(true)
        },
        {
          label: 'No',
          onClick:null
        }
      ]
    });
  };
 
  render() {
    const Elem = this.props.element || 'div';
    return (
      <Elem className={this.props.classList || " "} onClick={this.submit}>
        {this.props.children}
      </Elem>
    );
  }
}
export default Confirm;